import app from '@/app';

/* @ngInject */
function translationConfig($translateProvider, tmhDynamicLocaleProvider, $translatePartialLoaderProvider) {
	$translateProvider.useLoader('$translatePartialLoader', {
		urlTemplate: 'i18n/{lang}/{part}.json'
	});

	$translatePartialLoaderProvider.addPart('global');

	$translateProvider.preferredLanguage('pt-br');
	$translateProvider.useStorage('translationStorageProvider');
	$translateProvider.useSanitizeValueStrategy('escaped');
	$translateProvider.fallbackLanguage('pt-br');
	$translateProvider.addInterpolation('$translateMessageFormatInterpolation');

	tmhDynamicLocaleProvider.localeLocationPattern('i18n/angular-locale_{{locale}}.js');
	tmhDynamicLocaleProvider.defaultLocale('pt-br');
	tmhDynamicLocaleProvider.useCookieStorage();
	tmhDynamicLocaleProvider.storageKey('NG_TRANSLATE_LANG_KEY');
}

app.config(translationConfig);
